<template>
  <div class="image-box">
    <div class="image-item" @click="onItemSelect(item)" v-for="item in authedAwemeList" :key="item.video_info.item_id">
      <div class="aweme-info" :class="{ active: selectedVideoIds.includes(item.video_info.item_id) }">
        <p class="aweme-name" :title="item.aweme_name">
          {{ item.aweme_name }}
        </p>
        <i class="checked el-icon-circle-check" v-if="selectable" />
        <i class="remove el-icon-circle-close" v-else @click="$emit('remove', item)" />
      </div>
      <el-tag class="preview-btn" @click.stop="onItemPreview(item)">预览</el-tag>
      <div class="aweme-desc" :title="item.video_info.title">{{ item.video_info.title }}</div>
      <img loading="lazy" :src="item.video_info.video_cover_url" alt="" />
    </div>
  </div>
</template>

<script setup>
import { toRef, computed } from 'vue'
// eslint-disable-next-line
const props = defineProps({
  data: Array,
  value: {
    type: Array,
    default: () => []
  },
  selectable: {
    type: Boolean,
    default: true
  }
})
// eslint-disable-next-line
const emit = defineEmits(['input'])
const authedAwemeList = toRef(props, 'data')
const selectedVideoIds = computed(() => props.value.map((i) => i.video_info?.item_id))

function onItemSelect(item) {
  if (!props.selectable) return
  item.preview_url = item.video_info.video_cover_url
  item.vertical = true
  let res = props.value
  if (selectedVideoIds.value.includes(item.video_info.item_id)) {
    res = props.value.filter((i) => i.video_info.item_id !== item.video_info.item_id)
  } else {
    res.push(item)
  }
  emit('input', res)
}

function onItemPreview(item) {
  window.open(item.video_info.aweme_play_url)
}
</script>

<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

@mixin desc {
  position: absolute;
  padding: 4px 6px;
  left: 0;
  width: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);
}
.image-box {
  overflow: auto;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  .image-item {
    height: 254px;
    background: #eee;
    cursor: pointer;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    width: 143px;
    display: flex;
    align-items: center;
    &:hover {
      opacity: 0.9;
    }

    .preview-btn {
      position: absolute;
      z-index: 1;
      left: 4px;
      top: 36px;
    }

    .aweme-desc {
      @include desc;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      bottom: 0;
      color: #e0e0e0;
      font-size: 12px;
    }

    .aweme-info {
      @include desc;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .aweme-name {
        color: #fff;
        font-weight: 700;
        font-size: 12px;
        white-space: nowrap;
        line-height: 22px;
        width: 85px;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      &.active {
        // background: rgb(221, 124, 6);
        .remove {
          display: block;
          color: #fff;
          font-size: 18px;
        }
        .el-icon-circle-check {
          display: block;
          color: $green;
          font-size: 18px;
        }
      }

      .el-icon-circle-check {
        display: none;
      }
    }
  }
  img {
    width: 100%;
  }
}
</style>
